// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Person_Wrapper__Subgs","Image":"Person_Image__tZy_F","Name":"Person_Name__TnjRJ"};